import { StrikeReportBody } from './strike-report-body';
import './styles.scss';

const StrikeReport = () => {
  return (
    <div className="strike-report-container">
      <StrikeReportBody />
    </div>
  );
};

export default StrikeReport;
